import React from 'react';
import { IconSvgProps } from '@models/common';

const PenSparkle: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M13.4279 2.59492C14.5263 1.49659 16.307 1.49659 17.4054 2.59492C18.5037 3.69327 18.5037 5.47408 17.4054 6.57243L5.93232 18.0455C5.79558 18.1822 5.6101 18.2591 5.41672 18.2591H2.50003C2.09732 18.2591 1.77083 17.9326 1.77083 17.5299V14.554C1.77083 14.3606 1.84769 14.1752 1.98444 14.0384L13.4279 2.59492ZM3.22922 14.856V16.8008H5.11465L14.6085 7.30675L12.6934 5.3917L3.22922 14.856ZM16.3742 3.6261C15.8453 3.09729 14.9879 3.09729 14.4591 3.6261L13.7247 4.36051L15.6398 6.27557L16.3742 5.54116C16.903 5.01232 16.903 4.15494 16.3742 3.6261Z'
        fill='currentColor'
      />
      <path
        d='M15.0708 13.4403C15.1306 13.2786 15.3596 13.2786 15.4195 13.4403L16.0188 15.06C16.0281 15.0852 16.0427 15.108 16.0617 15.127C16.0806 15.1459 16.1034 15.1606 16.1285 15.1699L17.7484 15.7692C17.9102 15.8291 17.9102 16.0581 17.7484 16.118L16.1287 16.7173C16.1036 16.7266 16.0807 16.7412 16.0618 16.7601C16.0428 16.7791 16.0282 16.8019 16.0188 16.827L15.4195 18.4468C15.3596 18.6087 15.1306 18.6087 15.0708 18.4468L14.4714 16.8272C14.4621 16.8021 14.4475 16.7792 14.4286 16.7603C14.4097 16.7413 14.3869 16.7267 14.3617 16.7173L12.7418 16.118C12.5801 16.0581 12.5801 15.8291 12.7418 15.7692L14.3616 15.1699C14.3867 15.1606 14.4095 15.146 14.4285 15.1271C14.4474 15.1081 14.4621 15.0853 14.4714 15.0602L15.0708 13.4403Z'
        fill='currentColor'
      />
      <path
        d='M4.0964 1.31234C4.168 1.11887 4.44198 1.11887 4.51359 1.31234L5.23055 3.24998C5.24165 3.28005 5.25913 3.30736 5.28177 3.33005C5.30442 3.35273 5.3317 3.37025 5.36175 3.38141L7.2996 4.09838C7.49307 4.16998 7.49307 4.44396 7.2996 4.51557L5.36198 5.23254C5.33191 5.24364 5.3046 5.26112 5.28191 5.28377C5.25923 5.30641 5.24171 5.3337 5.23055 5.36375L4.51359 7.30138C4.44198 7.49508 4.168 7.49508 4.0964 7.30138L3.37944 5.36397C3.36833 5.3339 3.35085 5.30659 3.32821 5.2839C3.30556 5.26122 3.27828 5.2437 3.24823 5.23254L1.31039 4.51557C1.11691 4.44396 1.11691 4.16998 1.31039 4.09838L3.24801 3.38141C3.27808 3.3703 3.30539 3.35283 3.32807 3.33018C3.35076 3.30753 3.36828 3.28025 3.37944 3.2502L4.0964 1.31234Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default PenSparkle;
